import React, { useState, useEffect, useRef } from 'react'

import classes from './PopupMinigameStars.module.css'
import Popup from '@/components/shared/Popup/Popup';
import Button from '@/components/shared/Button/Button';
import { CountUp } from 'countup.js';
import clsx from 'clsx';
import PopupsManager from 'react-sdk/PopupsManager';
import AppState, { POPUPS } from '@/js/AppState';
import WaveSection from '@/components/shared/WaveSection/WaveSection';
import Rays from '@/components/shared/Rays/Rays';
import Star from '@/components/shared/Star/Star';
import Texts from 'react-sdk/Texts';
import Minigames from '@/js/Minigames/Minigames';
import FtueHelper from '@/js/FtueHelper';




const PopupMinigameStars = () => {
  let mg = PopupsManager.getData(POPUPS.MINIGAME_STARS)

  if(!mg) return null

  const scoreRef = useRef(null)

  const [currentval, setCurrentval] = useState(0);
  useEffect(() => {

    let loc = PopupsManager.getData(POPUPS.LOCATION)

    if(!loc) {
      Minigames.refreshGlobalScore()
      return
    }
    
    if(FtueHelper.hasShownFtue("intro_03")) {
      FtueHelper.openFtues(["intro_03"], "map");
    }
    
    AppState.dials.playSequence("Dials", `poi${loc.id}_postAct`, () => {
      setTimeout(() => {
        Minigames.refreshGlobalScore()
      }, 200)
    })
  }, []);

  function handleClick() {
    PopupsManager.close(POPUPS.MINIGAME_STARS)
  }

  const getThresholdText = (th) => {
    return th
  }

  const getScoreText = (score) => {
    return score === Number.MAX_SAFE_INTEGER ? 0 : score
  }

  const stars = mg.getStars()
  const desc_id = `minigames_${mg.type}_score_description`

  return (
    <Popup className={classes.PopupMinigameStars}>

      <div className={classes.title} dangerouslySetInnerHTML={{ __html: mg.name }} />

        <div className={classes.stars_ctnr}>
          <Star filled={stars >= 1}> { getThresholdText(mg.threshold_1) }</Star>
          <Star filled={stars >= 2}> { getThresholdText(mg.threshold_2) }</Star>
          <Star filled={stars >= 3}> { getThresholdText(mg.threshold_3) }</Star>
        </div>

      <Rays className={classes.rays} />

      <WaveSection globalClasses={classes.WaveSection} contentClasses={classes.WaveSection_content} color="#fff">
        <div className={classes.score_block}>
          {/* <div className={classes.score_block_title}>{Texts.get(`minigames_${mg.type}_score_title`)}</div> */}
          {/* <div className={classes.score_block_content} ref={scoreRef}/> */}
          {/* <div className={ classes.score_block_content}>{getScoreText(mg.score)}</div> */}

          { Texts.get(desc_id) !== desc_id && <div className={classes.score_block_description} dangerouslySetInnerHTML={{ __html: Texts.get(desc_id) }} /> }
        </div>
        <div className={classes.btn}>
          <Button onClick={handleClick}>Continuer</Button>
        </div>
      </WaveSection>
    </Popup>
  );
};

export default PopupMinigameStars;
